import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PRODUCT_IMAGES } from 'src/app/helpers/google-storage.helper';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CompanyRespiratorInserts } from 'src/app/models/company-respirator-inserts.model';
import { Employee } from 'src/app/models/employee.model';
import { CartItemsRequest } from 'src/app/models/requests/cart-items-request.model';
import { SelectedInsert } from 'src/app/models/local-storage/selected-insert.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { CompanyRespiratorInsertsService } from 'src/app/services/repositories/company-respirator-inserts.service';
import { EmployeeService } from 'src/app/services/repositories/employees.service';

@Component({
    selector: 'app-respirator-details',
    templateUrl: './respirator-details.component.html',
    styleUrls: ['./respirator-details.component.scss'],
    standalone: false
})

export class RespiratorDetailsComponent implements OnInit {
  toggleClass: boolean = true;
  queryParams: ParamMap | undefined;
  insertDetails: CompanyRespiratorInserts | undefined;
  style: string = '';
  employeeImage: string = '';
  imgUrl: string = '';
  isEditMode: boolean = false;
  selectedInsert: SelectedInsert | null | undefined;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _employeeService: EmployeeService,
              private _localStorageService: LocalStorageService,
              private _companyRespiratorInsertsService: CompanyRespiratorInsertsService,
              private _cartManagerService: CartManagerService) { }

  ngOnInit(): void {
    this._route.queryParams
      .subscribe(params => {
        this.isEditMode = params.isEditMode === 'true';
        this.selectedInsert = this._localStorageService.getSelectedStyle();
        if (this.selectedInsert != null) {
          this.getInsertDetails();
          this.getEmployeeInfo();
        }
        else {
          this._router.navigate(['/products/safety-eyewear']);
        }
      });

      this._route.queryParams
        .subscribe(params => {
          this.isEditMode = params.isEditMode === 'true';
      });
    }

  getEmployeeInfo() {
    this._employeeService.getEmployeeInfo()
    .subscribe((data: Employee) => {
      if (data) {
        this.employeeImage = data.unscaledImageName;
      }
    }, (error) => {
      console.log(error);
    });
  }

  getInsertDetails() {
    if (this.selectedInsert) {
      this._companyRespiratorInsertsService.getInsertDetails(this.selectedInsert.companyInsertId)
      .subscribe((data: CompanyRespiratorInserts) => {
        if (data) {
          this.insertDetails = data;
          this.setImgUrl();
        }
      }, (error) => {
        console.log(error);
      });
    }
  }

  setImgUrl() {
    this.imgUrl = `${PRODUCT_IMAGES.respiratorInserts}${this.insertDetails?.imageName}`
  }

  navigateToLenses() {
    this.saveInsertSelection();
    const queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
    this._router.navigate(['lens-selection'], { queryParams: queryParams });
  }

  saveInsertSelection() {
    if (this.insertDetails) {
      const cartItem : CartItemsRequest = {
        itemCategory: ORDER_CATEGORY.respiratorInserts,
        itemDescription: this.insertDetails.style,
        itemImageName: this.insertDetails.imageName,
        itemDetails: [{
                        id: this.insertDetails.respiratorInsertId,
                        itemType: ITEM_REVENUE_CATEGORY.insert,
                        itemDescription: this.insertDetails.style
                      }]
      };
      this._cartManagerService.clearTempCartItem();
      this._cartManagerService.saveTempCartItem(cartItem);
    }
  }


}
